/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import { PredictionState } from '@dynameat/views/pointOfSale/models';

export class MenuRecommendationPreview extends DaoModel {
  constructor(guid, menuGuid, title, isRecommendationValidated, recommendationState) {
    super(guid);
    this.menuGuid = menuGuid;
    this.title = title || '';
    this.isRecommendationValidated = isRecommendationValidated || false;
    this.recommendationState = recommendationState || PredictionState.INITIAL;
  }

  static toInstance(props = {}) {
    return new MenuRecommendationPreview(props.guid, props.menu_guid, props.title, props.is_recommendation_validated, props.recommendation_state);
  }

  isGenerated() {
    return this.recommendationState === PredictionState.GENERATED;
  }
}
